<ng-container *ngIf="!cargandoSurvey">
    <div fxLayout="column" fxLayoutAlign="start center" style="padding-top: 5%; margin-top: 15%;">
        <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
        <h1>{{'AVANCES.ENCUESTA.CARGANDO' | translate}}</h1>
    </div>
</ng-container>
<div *ngIf="cargandoSurvey">
    <div fxLayout="row" fxFlex="20" fxLayoutAlign="end center" class="firtsRow">
        <div class="col-lg-4 col-md-5 xs-margin-30px-bottom">
            <div class="team-single-img">
                <img src="{{rutaimagen}}" alt="">
            </div>
            <div class="bg-light-gray padding-30px-all md-padding-25px-all sm-padding-20px-all text-center">
                <h4 class="margin-10px-bottom font-size24 md-font-size22 sm-font-size20 font-weight-600">{{nombreEmpresa}}</h4>
                <p class="sm-width-95 sm-margin-auto"></p>
                <div class="margin-20px-top team-single-icons">
                    <ul class="no-margin">
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div fxLayout="row" fxFlex="80">
        <div class="col-lg-8 col-md-7">
            <div class="team-single-text padding-50px-left sm-no-padding-left">
                <div class="contact-info-section margin-40px-tb">
                    <ul class="list-style9 no-margin">
                        <li>
                            <div class="row" fxFlexAlign="end center">
                                <div class="col-md-5 col-5" fxLayout="column">
                                    <strong class="margin-10px-left text-orange" fxLayoutAlign="start end">{{'AVANCES.TITULOS.NAME' | translate}}</strong>
                                </div>
                                <div class="col-md-7 col-7" fxLayout="column">
                                    <p>{{name}}</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="row" fxFlexAlign="end center">
                                <div class="col-md-5 col-5" fxLayout="column">
                                    <strong class="margin-10px-left text-orange" fxLayoutAlign="start end">{{'AVANCES.TITULOS.ESTADOS' | translate}}</strong>
                                </div>
                                <div class="col-md-7 col-7" fxLayout="column">
                                    <p>{{status | translate}}</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="row" fxFlexAlign="end center">
                                <div class="col-md-5 col-5" fxLayout="column">
                                    <strong class="margin-10px-left text-orange" fxLayoutAlign="start end">{{'AVANCES.TITULOS.FECHA1' | translate}}</strong>
                                </div>
                                <div class="col-md-7 col-7" fxLayout="column">
                                    <p> {{fechaInicio }}</p>

                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="row" fxFlexAlign="end center">
                                <div class="col-md-5 col-5" fxLayout="column">
                                    <strong class="margin-10px-left text-orange" fxLayoutAlign="start end">{{'AVANCES.TITULOS.FECHA2' | translate}}</strong>
                                </div>
                                <div class="col-md-7 col-7" fxLayout="column">
                                    <p>{{fechaFin }}</p>

                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

</div>